import { flowRight as compose } from 'lodash';
import queries from '~lib/common/queries/Medication';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';

import CaseMedications from './CaseMedications.vue';

const enhance = compose(
  dataView({ queries: { 
    fetch: queries.fetch,
    fetchById: queries.fetchById,
    save: queries.save,
    add: queries.save,
    remove: queries.remove,
  }, dontFetchOnLoad: true }),
  renameProps({ data: 'medications' }),
  renameProps({ itemData: 'medication' }),
  renameProps({ loadingItemId: 'loadingMedication' }),
);

export default enhance(CaseMedications);
